export default __webpack_public_path__ + "static/media/icons.f9c32d80.woff";